import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DataGridTable } from '@/ui'
import styles from './StructureInformation.module.scss'
import { getCurrentLanguage } from '@/i18next'
import { useDispatch, useSelector } from 'react-redux'
import { contractActionsSelectors } from '@features/contracts/model'
import { handbookThunks } from '@/entity/handbook'
import { message } from 'antd'

export const StructureInformation = ({ structure, deptTypeName, staffProject }) => {
	const { t } = useTranslation()
	const lang = getCurrentLanguage()
	const dispatch = useDispatch()
	const optionLang = lang === 'rus' ? 'nameRu' : 'nameKz'
	const langPositionName = lang === 'rus' ? 'rus' : 'kz'
	const { districts, regions } = useSelector(contractActionsSelectors.options)
	let districtName = districts?.find((item) => item.code === structure?.ddistrictCode)
	let regionName = regions?.find((item) => item.code === structure?.dregionCode)
	let errors = structure.level === 0 ? staffProject.errors : structure.errors
	const [district, setDistrict] = useState(districtName)
	const [region, setRegion] = useState(regionName)

	useEffect(() => {
		const addressConfig = [
			{ field: districtName, code: structure?.ddistrictCode, setter: setDistrict, name: 'district' },
			{ field: regionName, code: structure?.dregionCode, setter: setRegion, name: 'region' },
		]

		addressConfig.forEach(({ field, code, setter, name }) => {
			if (!field && code) {
				dispatch(
					handbookThunks.getKatoByCode({
						data: { code },
						onSuccess: (res) => setter(res[optionLang]),
						onError: (err) => {
							message.error(t('unknown_error', { name }), err)
							setter('-')
						},
					})
				)
			}
		})
	}, [])

	const errorInformation = () => {
		const errorDescriptions = errors.map((error) => error.code + ': ' + error[optionLang])
		return [
			{
				title: t('staff.errors'),
				data: errorDescriptions.join(',\n'),
			},
		]
	}

	const districtData = districtName
		? districtName[langPositionName]
		: typeof region === 'object'
		? region[optionLang]
		: region || '-'

	const regionData = regionName
		? regionName[langPositionName]
		: typeof district === 'object'
		? district[optionLang]
		: district || '-'

	const structureInformation = () => {
		return [
			{ title: t('staff_modal.code'), data: structure.dept.code },
			{ title: t('staff_modal.structure_type'), data: deptTypeName },
			{ title: t('staff_modal.structure_name_kz'), data: structure.dept.nameKz },
			{ title: t('staff_modal.structure_name'), data: structure.dept.nameRu },
			...(structure.ddistrictCode ? [{ title: t('region'), data: districtData }] : []),
			...(structure.dregionCode ? [{ title: t('district'), data: regionData }] : []),
		]
	}

	const staffingInformation = () => {
		return [
			{ title: t('staff_modal.order_date'), data: staffProject.orderDate },
			{ title: t('staff_modal.order_number'), data: staffProject.orderNumber },
			{ title: t('staff_modal.code'), data: structure.dept.code },
			{ title: t('staff_modal.structure_name_kz'), data: structure.dept.nameKz },
			{ title: t('staff_modal.structure_name'), data: structure.dept.nameRu },
			{ title: t('staff_modal.comment'), data: staffProject.note },
		]
	}
	return (
		<>
			<DataGridTable
				hideSubTitle
				titleClass={styles.tableTitleCell}
				title={structure.level === 0 ? t('staffing') : t('staff_modal.staff_information')}
				information={structure.level === 0 ? staffingInformation() : structureInformation()}
			/>
			{errors?.length > 0 && (
				<DataGridTable
					hideSubTitle
					titleClass={styles.tableTitleCell}
					dataClass={styles.dataClassCell}
					information={errorInformation()}
				/>
			)}
		</>
	)
}
